import { useState } from 'react';
import { Link } from 'react-router-dom';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { Drawer } from './styling/StyledComponents';
import { productList } from './js/productParams';

export default function ProductSelection(props) {
  const { drawerOpen, toggleDrawer } = props;
  const [ product, setProduct ] = useState("");

  const handleClick = (selection) => {
    setProduct(selection);
  }

  const MenuItems = ({pcategory}) => {
		return (
      <>
        {productList().map ((pl) => 
          pl.productCategory === pcategory &&
            <ListItemButton 
              key={pl.product}
              component={Link}
              to={pl.linkTo}
              dense={true}
              selected={product===pl.product}
              sx={{
                '&.Mui-selected': {
                  backgroundColor: "rgba(85,108,214,0.1)",
                  fontStyle: 'italic'
                }
              }} 
            >
              <ListItemText 
                primary={pl.displayName}
                onClick={() => handleClick(pl.product)}
              />
            </ListItemButton>
        )}
      </>
    )
	};

  return (
    <Drawer variant="permanent" open={drawerOpen}>
      <Toolbar
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          px: [1],
        }}
      >
        <IconButton onClick={toggleDrawer}>
          <ChevronLeftIcon />
        </IconButton>
      </Toolbar>
      <Divider />

      <List>
        <>
          <ListItemButton dense={true}>
            <ListItemText 
              primary={<b>- Hourly Data Products -</b>}
            />
          </ListItemButton>
          <MenuItems pcategory="hourly" />

          <ListItemButton dense={true}>
            <ListItemText 
              primary={<b>- Gridded Data Products -</b>}
            />
          </ListItemButton>
          <MenuItems pcategory="gridded" />

        </>
      </List>
  </Drawer>
  )
};

/* FOR DAILY PRODUCTS
            <ListItemButton dense={true}>
              <ListItemText 
                primary={<b>- Daily Data Products -</b>}
              />
            </ListItemButton>
            <MenuItems pcategory="daily-ss" />

*/